import * as angular from "angular";
import { Constants as constants } from "@constants/shared";
import { OnboardingRepo as OnboardingRepo } from "@services/onboarding.repo";
import { clientView } from "./clientView";
import {loginClient} from "./login.modal"


export const clientViewModule = "clientonboarding";

angular
  .module(clientViewModule, [
    "ui.router",
    "dataGrid",
    "pagination",
    "angular-loading-bar",
    "angularModalService"
  ])
  .constant("config", constants.Default)
  .service("onboardingRepo", OnboardingRepo)
  .component("clientonboarding", clientView)
  .component("loginClient", loginClient);




// WEBPACK FOOTER //
// ./src/app/onboarding/client/clientview.index.ts